// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A-59M","label":"styles_label__3kknA"};